import React from 'react';
import get from 'lodash/get';
import { Controller, FieldError, useFormContext } from 'react-hook-form';
import { InputNumberMask } from '../../../CommonComponents/OPL/Input/InputNumberMask';

interface Props {
  formKey?: string;
}

export const HypotheticalReturn = ({
  formKey = 'ExcessCashFlowStrategy.data.hypotheticalReturnPercent',
}: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, formKey) as FieldError | undefined;

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field }) => (
        <InputNumberMask
          {...field}
          label="Input the percentage return to be applied to your excess cash savings"
          rightIcon="far fa-percent"
          //   decimalScale={2}
          allowNegative={false}
          formVariant={error && 'error'}
          helperText={error?.message}
        />
      )}
    />
  );
};
